import CustomTable from "@/components/CustomTable";
import CustomTableColumn from "@/components/CustomTableColumn";
import PageLine from "@/components/page";
import axios from "axios";
import { baseUrlt } from "@/api";

export let mixinList = {
  data() {
    return {
      // 分页
      total: 0, // 总数
      tableData: [],
      delid: '',
      type: '',
      title: '新增',
      centerDialogVisible: false,
      dialogVisible: false,
      exportBtnTitle: '导出列表',
      delText: '是否删除',
      ruleFormTep: {},
      tHeader: [],
      filterVal: [],
      isKeep: false,
      exportFileTitle: '',
      exportUrl: '',
      multipleSelection: [],
      widthVar: "168px",
      baseUrlt,
      needQuery: true,
    };
  },
  components: {
    PageLine,
    CustomTableColumn,
    CustomTable,
  },
  activated() { // 使用keepAlive
    if (this.isKeep) {
      console.log('keepAlive')
      this.handleQuery();
    }
    this.isKeep = true
  },
  deactivated() {
  },
  created() {
    this.exportTitle = this.exportBtnTitle
  },
  mounted() {
    if (this.ruleForm) {
      this.ruleFormTep = this.$until.easyDeepCopy(this.ruleForm) //重置对象
    }
    if (!(this.$parent && this.$parent.$el && this.$parent.$el.className == 'el-tab-pane') && this.needQuery) {
      this.handleQuery();
    }
    if (this.$refs.pageHeader) {
      this.widthVar = `${this.$refs.pageHeader.textContent.length * 22}px`
    }
    // 移动端:在标题下方居中挂「操作」开关(页面标题、每个弹窗标题各一个)
    if (window.innerWidth < 1000) {
      this.initMobileOperateSwitch()
    }
  },
  beforeDestroy() {
    if (this._dialogFormObserver) {
      this._dialogFormObserver.disconnect()
      this._dialogFormObserver = null
    }
  },
  methods: {
    //查询
    onSubmit() {
      this.$refs.pageChild.page = 1
      this.$refs.pageChild.page_size = 10
      this.getList()
    },
    // 页面级查询区(排除弹窗内部的表单)
    pageInlineForm() {
      return Array.from(document.querySelectorAll('.el-form--inline')).find(f => !f.closest('.el-dialog')) || null
    },
    // 移动端:在标题下方挂「操作」开关(页面标题、每个弹窗标题各一个)
    initMobileOperateSwitch() {
      this.$nextTick(() => this.syncOperateBars())
      // 弹窗是异步渲染出来的,监听页面 DOM 变化补挂
      let timer = null
      this._dialogFormObserver = new MutationObserver(() => {
        clearTimeout(timer)
        timer = setTimeout(() => this.syncOperateBars(), 60)
      })
      this._dialogFormObserver.observe(this.$el, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['style', 'class'],
      })
    },
    syncOperateBars() {
      // 弹窗打开时收起外层的操作区,保证操作只在弹窗里展开
      const dlg = Array.from(document.querySelectorAll('.content .el-dialog'))
        .filter(d => d.offsetParent !== null)
        .pop()
      if (dlg) {
        const pageForm = this.pageInlineForm()
        if (pageForm && pageForm.style.display === 'flex') pageForm.style.display = 'none'
      }
      this.attachPageOperateBar()
      this.scanDialogOperateBar()
    },
    mobileOperateShown(forms) {
      return (forms || []).some(f => getComputedStyle(f).display !== 'none')
    },
    syncDialogOperateIcon(icon, forms) {
      if (!icon) return
      icon.innerHTML = this.mobileOperateShown(forms)
        ? '<i class="el-icon-circle-close" style="font-size:20px;"></i>'
        : '<i class="el-icon-s-operation" style="font-size:20px;"></i>'
    },
    // 页面标题里的操作开关(沿用原来的小图标,定位在标题右下角)
    attachPageOperateBar() {
      const header = this.$refs.pageHeader
      const form = this.pageInlineForm()
      if (!header || !form) return
      let icon = header.querySelector('.header-info-icon')
      if (!icon) {
        icon = document.createElement('span')
        icon.className = 'header-info-icon'
        icon.style.cursor = 'pointer'
        icon.onclick = () => this.togglePageOperate()
        header.appendChild(icon)
      }
      const shown = getComputedStyle(form).display !== 'none'
      icon.innerHTML = shown
        ? '<i class="el-icon-circle-close" style="font-size:20px;"></i>'
        : '<i class="el-icon-s-operation" style="font-size:20px;"></i>'
    },
    togglePageOperate() {
      const form = this.pageInlineForm()
      if (!form) return
      const shown = getComputedStyle(form).display !== 'none'
      form.style.display = shown ? 'none' : 'flex'
      this.attachPageOperateBar()
    },
    // 各弹窗:操作开关挂在标题栏右上角、关闭按钮左边
    scanDialogOperateBar() {
      document.querySelectorAll('.content .el-dialog').forEach(dlg => {
        const forms = Array.from(dlg.querySelectorAll('.el-form--inline'))
        // 弹窗里没有可显隐的操作表单就不挂
        if (!forms.length) return
        const existed = dlg.querySelector('.dialog-operate-icon')
        if (existed) {
          this.syncDialogOperateIcon(existed, forms)
          return
        }
        const header = dlg.querySelector('.el-dialog__header')
        if (!header) return
        const icon = document.createElement('span')
        icon.className = 'header-info-icon dialog-operate-icon'
        icon.title = '展开/收起操作'
        icon.onclick = () => {
          const shown = this.mobileOperateShown(forms)
          forms.forEach(f => { f.style.display = shown ? 'none' : 'flex' })
          this.syncDialogOperateIcon(icon, forms)
        }
        header.appendChild(icon)
        this.syncDialogOperateIcon(icon, forms)
      })
    },
    handleBatchDel() {
      if (this.multipleSelection.length) {
        this.delid = this.multipleSelection.join(',')
        this.dialogVisible = true
      } else {
        this.$message({
          type: 'warning',
          center: true,
          message: '至少选择一条数据！',
        });
      }
    },
    handleSelectionChange(val, key) {
      console.log(val, key)

      this.multipleSelection = val.map(item => item.id);
    },
    handleExportByUrl(obj = {}, method = 'get') {
      this.exportTitle = '导出中...'
      if (!this.exportUrl) {
        this.$message.warning("url未找到")
        return
      }
      axios({
        method: method,
        url: this.exportUrl,
        responseType: 'blob',
        params: obj,
        withCredentials: true,
        headers: {
          token: this.$store.state.userInfo ? this.$store.state.userInfo.userToken : ''
        }
      }).then(res => {
        // 这里 data 是返回来的二进制数据
        var blob = new Blob([res], {
          type: "application/x-msdownload;charset=UTF-8",
        });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', this.downloadName); // 设置下载文件名
        document.body.appendChild(link);
        link.click();

        setTimeout(() => {
          this.exportTitle = this.exportBtnTitle
        }, 2000)
      })
      // let params = this.$until.deleteNullPrototype(obj), keys = Object.keys(params), url = this.exportUrl
      // if (this.exportUrl) {
      //   keys.map((item, index) => {
      //     if (index == 0) {
      //       url += `?${item}=${params[item]}`
      //     } else {
      //       url += `&${item}=${params[item]}`
      //     }
      //   })
      //   const link = document.createElement('a');
      //   let fname = this.exportFileTitle;
      //   link.href = url;
      //   link.setAttribute('download', fname);
      //   document.body.appendChild(link);
      //   console.log(url)
      //   link.click();
      //   // window.location.href = url
      //   setTimeout(() => {
      //     this.exportTitle = this.exportBtnTitle
      //   }, 2000)
      // } else {
      //   this.$message.warning("url未找到")
      // }
      // console.log(params, keys)

    },
    handleAdd(callback = () => { }) {
      this.type = 'add'
      this.title = "新增"
      if (this.selectName) {
        this.selectName = ''
      }
      this.ruleForm = this.$until.easyDeepCopy(this.ruleFormTep)
      callback()
      this.centerDialogVisible = true;
      this.$nextTick(() => {
        if (this.$refs.ruleForm) {
          this.$refs.ruleForm.clearValidate()
        }
      });

    },
    confirmBox(type, title, params, $fun) {
      this.$confirm(title, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: type,
      })
        .then(() => {
          $fun(params)
        })
        .catch(() => {
          // this.$message({
          //   type: 'info',
          //   message: '已取消删除',
          // });
        });
    },
    clearState() {
      this.resetForm('ruleForm')
      this.ruleForm = this.$until.easyDeepCopy(this.ruleFormTep)
      this.centerDialogVisible = false;
      if (this.type == 'add') {
        this.handleQuery();
      } else {
        this.getList()
      }
    },
    handleEdit(row, filterArr = ['updated_at', 'deleted_at', 'created_at', 'login_time']) {
      this.type = 'edit'
      this.title = "编辑"
      this.ruleForm = this.$until.delProp(row, filterArr)
      this.centerDialogVisible = true;
    },
    handleEditNew(row, extraKeys = ['id'], callback = () => { }) {
      this.type = 'edit'
      this.title = "编辑"
      this.ruleForm = this.$until.easyDeepCopy(this.ruleFormTep)
      this.ruleForm = this.assignFormObj(this.ruleForm, row, extraKeys)
      callback(row)
      this.centerDialogVisible = true;
    },
    handleDetailNew(row, callback = () => { }) {
      this.type = 'view'
      this.title = "详情"
      this.ruleForm = this.$until.easyDeepCopy(this.ruleFormTep)
      this.ruleForm = this.assignFormObj(this.ruleForm, row)
      callback()
      this.centerDialogVisible = true;
    },
    handleEditCallBackSetStruc({
      dep = 'structure_1',
      major = 'major',
      class_name = 'class_name',
      row = {}
    } = {}) {
      if (row[dep]) {
        this.selectName = `${row[dep]}${row[major] ? `-${row[major]}` : ''}${row[class_name] ? `-${row[class_name]}` : ''}`;
      }
    },
    handleEditMultiple({ keys = [], row = {} } = {}) {
      for (let i = 0; i < keys.length; i++) {
        if (row[keys[i]]) {
          this.ruleForm[keys[i]] = row[keys[i]].split(',');
        }
      }
    },
    handleEditCallBackSetFile({
      ref = 'uploadd',
      fileField = 'file',
      row = {}
    } = {}) {
      this.$nextTick(() => {
        if (row[fileField]) {
          this.$refs[ref].setRefFileList(row[fileField]);
        } else {
          this.$refs[ref].setRefFileList('');
        }
      });
    },

    assignFormObj(formObj, rowObj, extraKeys = []) {
      Object.keys(formObj).forEach(key => {
        if (rowObj.hasOwnProperty(key)) {
          formObj[key] = rowObj[key];
        }
      });
      // 2. 添加指定的额外属性（如 id）
      extraKeys.forEach(key => {
        if (rowObj.hasOwnProperty(key)) {
          formObj[key] = rowObj[key];
        }
      });
      return formObj
    },
    handleDelet(id) {
      this.delid = id
      this.dialogVisible = true
    },
    submitFormByFun(formName, $fun) {
      this.$refs[formName].validate((valid) => {
        console.log(valid)
        if (valid) {
          $fun()
        } else {
          // console.log('error submit!!');
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      if (this.selectName) {
        this.selectName = ''
        this.selectNode = ''
      }
    },
    handleExport() {
      this.exportTitle = '导出中...'
      if (this.$refs.table && this.$refs.table.columns && this.tHeader.length == 0) {
        this.$refs.table.columns.map(item => {
          if (item.property) {
            this.tHeader.push(item.label)
            this.filterVal.push(item.property)
          }
        })
      }
      this.exportExcel()
    },
    getDataList(method, obj = {}) {
      let params = {
        page: 1,
        size: 99999
      }
      if (obj) {
        params = Object.assign({}, params, obj)
      }
      return this.$api.query[method](params);
    },
    exportExcel() {
      let that = this
      require.ensure([], () => {
        const { export_json_to_excel } = require('../../../Excel/Export2Excel');//注意这个Export2Excel路径,具体引用路径根据你自己的组件层级确定
        const tHeader = this.tHeader;   // 上面设置Excel的表格第一行的标题
        const filterVal = this.filterVal; // 上面的index、nickName、name是tableData里对象的属性key值
        const list = this.tableData;  //把要导出的数据tableData存到list
        const data = this.formatJson(filterVal, list);
        export_json_to_excel(tHeader, data, this.tableName);//最后一个是表名字
        setTimeout(function () { that.exportTitle = '导出列表' }, 2000)
      })
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]))
    },
    //检查手机号
    isCellPhone(val) {
      if (!/^1(3|4|5|6|7|8|9)\d{9}$/.test(val)) {
        return false;
      } else {
        return true;
      }
    },
  }
};
